import React from "react";
import styles from "./Checklist.module.css";
import { WHATSAPP_LINK } from "../siteData";

const INCLUDED = [
  "Sweeping, vacuuming and mopping all floors, including balconies",
  "Removing construction dust from walls, ceilings and skirting",
  "Wiping cabinets, shelves, hinges and handles inside and out",
  "Cleaning windows, sills and frames",
  "Bathroom and kitchen fixtures cleaned and sanitised",
  "Clearing general debris so the space is ready to use",
];

const GOOD_TO_KNOW = [
  "Heavy paint, cement or rust stains may need a specialist add-on",
  "Furniture assembly and heavy item disposal aren't included",
  "Floor polishing or waxing is available as a separate service",
  "Sensitive surfaces are wiped with a damp or dry cloth only",
];

export default function Checklist() {
  return (
    <section id="checklist" className={styles.section}>
      <div className={`container ${styles.grid}`}>
        <div className={styles.copy}>
          <p className="jc-eyebrow">Post-Renovation Cleaning</p>
          <h2 className={styles.title}>Move-in ready after every renovation</h2>
          <p className={styles.desc}>
            Renovation work leaves behind fine dust, paint marks and debris
            that a normal clean won't shift. Here's what our post-renovation
            and post-construction cleaning covers.
          </p>
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noreferrer"
            className={`jc-btn jc-btn-primary ${styles.cta}`}
          >
            Ask About This Service
          </a>
        </div>

        <div className={styles.panels}>
          <div className={styles.panel}>
            <h3 className={styles.panelTitle}>
              <span className={styles.panelIcon}>✓</span>
              What's Included
            </h3>
            <ul className={styles.list}>
              {INCLUDED.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>

          <div className={`${styles.panel} ${styles.panelAlt}`}>
            <h3 className={styles.panelTitle}>
              <span className={styles.panelIconAlt}>i</span>
              Good to Know
            </h3>
            <ul className={styles.list}>
              {GOOD_TO_KNOW.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
